import { render } from "./DailyTargetBlock.vue?vue&type=template&id=0a87073a"
import script from "./DailyTargetBlock.vue?vue&type=script&lang=js"
export * from "./DailyTargetBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__